import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface CarData {
  make?: string;
  model?: string;
  variant?: string;
  color?: string;
}

interface CarDataState {
  copilotCarData: CarData;
}

const initialState: CarDataState = {
  copilotCarData: {
    make: "",
    model: "",
    variant: "",
    color: "",
  },
};

const carDataSlice = createSlice({
  name: "carData",
  initialState,
  reducers: {
    setCopilotCarData: (state, action: PayloadAction<CarData>) => {
      state.copilotCarData = { ...state.copilotCarData, ...action.payload };
    },
    clearCopilotCarData: (state) => {
      state.copilotCarData = initialState.copilotCarData;
    },
  },
});

export const { setCopilotCarData, clearCopilotCarData } = carDataSlice.actions;
export default carDataSlice.reducer;
